export type PatentId = "BE98947" | "FR221035" | "US557079" | "US853715" | "US1003119";

export type PatentRecord = {
  id: PatentId;
  label: string;
  title: string;
  office: string;
  issued: string;
  href: string;
  blurb: string;
  images: { src: string; alt: string }[];
};

export const patents: Record<PatentId, PatentRecord> = {
  BE98947: {
    id: "BE98947",
    label: "Belgian patent 98,947",
    title: "Straight-pull bolt gun",
    office: "Belgian Patent Office",
    issued: "23 March 1892",
    href: "https://worldwide.espacenet.com/patent/search?q=pn%3DBE98947",
    blurb:
      "Mondragón’s first grant for the straight-pull, filed during his stay in Belgium. Digitized drawing plates are not online in the usual registries; Espacenet holds the bibliographic record.",
    images: [],
  },
  FR221035: {
    id: "FR221035",
    label: "French patent 221,035",
    title: "Straight-pull bolt gun",
    office: "French Patent Office",
    issued: "20 April 1892",
    href: "https://worldwide.espacenet.com/patent/search?q=pn%3DFR221035A",
    blurb:
      "The French counterpart to the 1892 Belgian grant, covering the same straight-pull action. Espacenet holds the bibliographic record.",
    images: [],
  },
  US557079: {
    id: "US557079",
    label: "United States patent 557,079",
    title: "Breech Loading Bolt Gun",
    office: "United States Patent Office",
    issued: "24 March 1896 · filed 8 February 1893",
    href: "https://patents.google.com/patent/US557079A",
    blurb:
      "The U.S. grant for the straight-pull: radial locking lugs in helical receiver grooves, three-position selector, and en-bloc clip feed.",
    images: [
      { src: "/assets/patents/us557079-1.png", alt: "US 557,079 drawing sheet 1, breech and bolt" },
      { src: "/assets/patents/us557079-2.png", alt: "US 557,079 drawing sheet 2" },
    ],
  },
  US853715: {
    id: "US853715",
    label: "U.S. patent 853,715",
    title: "Firearm",
    office: "United States Patent Office",
    issued: "14 May 1907 · application 219,989, 8 August 1904",
    href: "https://patents.google.com/patent/US853715A",
    blurb:
      "The gas-operated self-loader. A piston under the barrel cams the bolt open through the charging handle; a switch on that handle cuts the gas so the rifle can still be cycled by hand.",
    images: [
      { src: "/assets/patents/us853715-1.jpg", alt: "US 853,715 patent drawing, rifle in section" },
      { src: "/assets/patents/us853715-2.jpg", alt: "US 853,715 patent drawing, bolt and receiver" },
    ],
  },
  US1003119: {
    id: "US1003119",
    label: "U.S. patent 1,003,119",
    title: "Combined Weapon and Tool",
    office: "United States Patent Office",
    issued: "12 September 1911 · application 631,283, 6 June 1911",
    href: "https://patents.google.com/patent/US1003119A",
    blurb:
      "The spade-bayonet: a pointed, channelled blade that mounts on the rifle and doubles as a digging tool.",
    images: [{ src: "/assets/patents/us1003119-1.png", alt: "US 1,003,119 drawing, spade-bayonet blade" }],
  },
};
